module.exports = __webpack_public_path__ + "static/media/orangeCalendarIcon.d74c2cf2.svg";